export const storageKeys = {
    Token: "token",
} as const;
